import firebase from 'firebase/app'
import 'firebase/firestore'

var config = {
  apiKey: 'AIzaSyCGWUYcFI_8-dosNXZeSk8CETdnI7W0lSk',
  authDomain: 'backend-engineering-website.firebaseapp.com',
  databaseURL: 'https://backend-engineering-website.firebaseio.com',
  projectId: 'backend-engineering-website',
  storageBucket: '',
  messagingSenderId: '593877124444'
}

firebase.initializeApp(config)

export const firestore = firebase.firestore()

firestore.settings({
  timestampsInSnapshots: true
})

export default firebase



// WEBPACK FOOTER //
// ./client/firebase.js